<template>
<div>

  <ApolloQuery :query="SEARCH_CITY2" :variables="{cityFilter: '%'+searchText+'%'}" :debounce="500" :skip="skip">
    <template slot-scope="{ result: { loading, error, data } }">
      <div v-if="loading"> Loading...</div>
      <div v-else-if="error"> Error Occurred. {{error}}</div>
      <div v-else>
        <AutoComplete :placeholder="placeholder" v-model="city" clearable
                      @on-search="onSearchCity" @on-select="onSelectCity" @on-clear="onClearCity">
          <Option v-for="(item, index) in data?data.city:[]" :value="item.city" :key="index">{{item.city}}</Option>
        </AutoComplete>
      </div>
    </template>
  </ApolloQuery>

</div>
</template>

<script>
import { SEARCH_CITY2 } from '../../graphql/queries/territories'
export default {
  name: "SearchCity",
  props: ['value', 'placeholder'],
  data(){
    return{
      SEARCH_CITY2,
      skip: true,
      searchText: ''
    }
  },
  computed: {
    city: {
      get() {
        return this.value;
      },
      set(val) {}
    }
  },
  methods:{
    onClearCity(){
      this.$emit('input', '');
    },
    onSearchCity(val){
      this.searchText = val;
      this.skip = false;
    },
    onSelectCity(city){
      this.$emit('input', city);
    }
  }
}
</script>

<style scoped>

</style>
